module.exports = __webpack_public_path__ + "img/joel-make-time1@2x.fe751def.png";